import { createStore, applyMiddleware, compose } from "redux";
import { taskMiddleware } from "react-palm/tasks";
import thunk from "redux-thunk";
import composedReducer from "./reducers/reducers";
import { pageNames } from "../shared/config/pageNames";

const initialState = {
  keplerGl: {},
  app: {
    currentPage: pageNames.Map,
    // analyzeSelected: null,
  },
  data: {
    storeStats: {},
    districtStats: {},
    selectedAnalyzeType: "",
    selectedAttribute: "",
  },
  reports: {
    type: "",
    stores: [],
    selectedStores: [],
    selectedAttributes: [],
    dailyPatterns: [],
    recentTrends: [],
    recentTrendsStats: [],
  },
};

// const composeEnhancers =
//   typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
//         // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
//       })
//     : compose;

const composeEnhancers = compose;

const store = createStore(
  composedReducer,
  initialState,
  composeEnhancers(applyMiddleware(taskMiddleware, thunk))
);

export default store;
